module.exports = {
      id: "technology-usage",
      viewBox: "0 0 22.958 22.633",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#technology",
      toString: function () {
        return this.url;
      }
    }